/* eslint-disable no-return-assign */
/* eslint-disable spaced-comment */
/* eslint-disable max-classes-per-file */
/* eslint-disable no-var */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
import {
  IEntity,
  LiteralObject,
  ViggoCoreColumnDef
} from 'viggo-sistemas-core-web';
import {
  COLUNAS_DEFAULT_PROJETO,
  COLUNAS_DEFAULT_SYSDAMIN
} from './colunas/colunas_default';

interface T extends IEntity {}

export interface IColunasSettingsUser {
  module: string;
  colunas: ViggoCoreColumnDef<T>[];
}

export class ValidadorSettingsUser {
  //COLUNAS
  colunas = [] as IColunasSettingsUser[];
  web_version = 'UNKNOWN';
  primeiro_acesso = true;

  constructor(public user_settings: LiteralObject, public isSysadmin: boolean) {
    const user_regras = user_settings['regras'] ?? {};
    const user_version = user_settings['version'] ?? {};
    const user_colunas = user_settings['colunas'] ?? [];
    this.primeiro_acesso = user_settings['primeiro_acesso'] ?? true;
    //COLUNAS
    this.colunas = this.getColunasMenu(
      user_colunas.filter(it => it !== null && it !== undefined),
      isSysadmin
    );
    this.web_version = user_version['web_version'] ?? 'UNKNOWN';
  }

  getColunasMenu(user_colunas: IColunasSettingsUser[], isSysadmin: boolean) {
    const defaultColumns = !isSysadmin
      ? COLUNAS_DEFAULT_PROJETO
      : COLUNAS_DEFAULT_SYSDAMIN;
    var result = [];
    var colunas = user_colunas ?? [];
    if (colunas.length !== 0) {
      result = Array.from(
        [...defaultColumns, ...colunas]
          .reduce((m, o) => m.set(o.module, o), new Map())
          .values()
      );
    } else {
      result = defaultColumns;
    }
    return result;
  }

  getUserSettingsBody(user_settings) {
    return (user_settings = {
      regras: {},
      version: {
        web_version: this.web_version
      },
      colunas: this.colunas,
      primeiro_acesso: this.primeiro_acesso
    });
  }
}
